import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import Logo from '../components/Logo'

function forcaSenha(senha) {
  const len = senha.length >= 8
  const upper = /[A-Z]/.test(senha)
  const num = /[0-9]/.test(senha)
  return { len, upper, num, score: (len ? 1 : 0) + (upper ? 1 : 0) + (num ? 1 : 0) }
}

export default function NovaSenha() {
  const navigate = useNavigate()
  const [pronto, setPronto] = useState(false)      // sessão de reset ativa
  const [invalido, setInvalido] = useState(false)  // link expirado/inválido
  const [senha, setSenha] = useState('')
  const [confirmar, setConfirmar] = useState('')
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState(false)
  const [loading, setLoading] = useState(false)
  const forca = forcaSenha(senha)
  const forcaCores = ['#eee', '#FCEBEB', '#FAEEDA', '#EAF3DE']

  useEffect(() => {
    // O Supabase injeta os tokens no hash da URL (#access_token=...&type=recovery)
    // onAuthStateChange dispara PASSWORD_RECOVERY quando detecta esses tokens
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setPronto(true)
      } else if (event === 'SIGNED_IN' && session) {
        // Às vezes o evento é SIGNED_IN em vez de PASSWORD_RECOVERY — aceita também
        const hash = window.location.hash
        if (hash.includes('type=recovery') || hash.includes('type=invite')) {
          setPronto(true)
        }
      }
    })

    // Timeout: se após 4s não veio nenhum evento válido, link é inválido/expirado
    const timer = setTimeout(() => {
      setPronto(prev => {
        if (!prev) setInvalido(true)
        return prev
      })
    }, 4000)

    return () => {
      subscription.unsubscribe()
      clearTimeout(timer)
    }
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    setErro('')
    if (forca.score < 3) return setErro('A senha não atende todos os requisitos.')
    if (senha !== confirmar) return setErro('As senhas não coincidem.')
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password: senha })
    setLoading(false)
    if (error) {
      setErro('Erro ao atualizar senha. Tente solicitar um novo link.')
    } else {
      setSucesso(true)
      setTimeout(() => navigate('/login'), 3000)
    }
  }

  // Link inválido ou expirado
  if (invalido) {
    return (
      <div style={s.wrap}>
        <div style={s.card}>
          <div style={s.logo}><Logo size={160} /></div>
          <div style={s.icon}>⚠️</div>
          <h1 style={s.title}>Link inválido ou expirado</h1>
          <p style={s.sub}>Este link de redefinição de senha não é mais válido. Links expiram em 24 horas.</p>
          <a href="/recuperar-senha" style={s.btnLink}>Solicitar novo link</a>
          <a href="/login" style={{ ...s.btnLink, background: '#0A2342', marginTop: 8 }}>Voltar ao login</a>
        </div>
      </div>
    )
  }

  // Aguardando evento do Supabase
  if (!pronto) {
    return (
      <div style={s.wrap}>
        <div style={s.card}>
          <div style={s.logo}><Logo size={160} /></div>
          <p style={{ textAlign: 'center', color: '#888', fontSize: 13 }}>Verificando link...</p>
        </div>
      </div>
    )
  }

  // Senha alterada com sucesso
  if (sucesso) {
    return (
      <div style={s.wrap}>
        <div style={s.card}>
          <div style={s.logo}><Logo size={160} /></div>
          <div style={s.icon}>✅</div>
          <h1 style={s.title}>Senha atualizada!</h1>
          <p style={s.sub}>Sua senha foi redefinida com sucesso. Você será redirecionado ao login em instantes.</p>
          <a href="/login" style={s.btnLink}>Ir para o login</a>
        </div>
      </div>
    )
  }

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}><Logo size={180} /></div>
        <h1 style={s.title}>Redefinir senha</h1>
        <p style={s.sub}>Escolha uma nova senha para sua conta</p>
        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>Nova senha</label>
            <div style={{ position: 'relative' }}>
              <input
                style={{ ...s.input, paddingRight: 40 }}
                type={mostrarSenha ? 'text' : 'password'}
                value={senha} onChange={e => setSenha(e.target.value)}
                placeholder="Mínimo 8 caracteres"
                autoComplete="new-password" required
              />
              <button type="button" onClick={() => setMostrarSenha(!mostrarSenha)} style={s.eyeBtn}>
                {mostrarSenha ? '🙈' : '👁'}
              </button>
            </div>
            <div style={{ height: 3, borderRadius: 2, marginTop: 5, background: forcaCores[forca.score], transition: 'background .2s' }} />
            <div style={s.reqs}>
              <span style={{ color: forca.len ? '#3B6D11' : '#999' }}>{forca.len ? '✓' : '✗'} Mínimo 8 caracteres</span>
              <span style={{ color: forca.upper ? '#3B6D11' : '#999' }}>{forca.upper ? '✓' : '✗'} Uma letra maiúscula</span>
              <span style={{ color: forca.num ? '#3B6D11' : '#999' }}>{forca.num ? '✓' : '✗'} Um número</span>
            </div>
          </div>
          <div style={s.field}>
            <label style={s.label}>Confirmar nova senha</label>
            <div style={{ position: 'relative' }}>
              <input
                style={{ ...s.input, paddingRight: 40 }}
                type={mostrarConfirmar ? 'text' : 'password'}
                value={confirmar} onChange={e => setConfirmar(e.target.value)}
                placeholder="Repita a senha"
                autoComplete="new-password" required
              />
              <button type="button" onClick={() => setMostrarConfirmar(!mostrarConfirmar)} style={s.eyeBtn}>
                {mostrarConfirmar ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          {erro && <p style={s.erro}>{erro}</p>}
          <button style={s.btn} type="submit" disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar nova senha'}
          </button>
        </form>
      </div>
    </div>
  )
}

const s = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', background: '#f5f5f5' },
  card: { background: 'white', borderRadius: 12, padding: '2rem', width: '100%', maxWidth: 400, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  logo: { display: 'flex', justifyContent: 'center', marginBottom: '1rem' },
  icon: { fontSize: 40, textAlign: 'center', marginBottom: 8 },
  title: { fontSize: 16, fontWeight: 500, textAlign: 'center', marginBottom: 4 },
  sub: { fontSize: 13, color: '#666', textAlign: 'center', marginBottom: '1.5rem' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', fontSize: 12, color: '#666', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  eyeBtn: { position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 },
  reqs: { display: 'flex', flexDirection: 'column', gap: 2, fontSize: 11, marginTop: 4 },
  btn: { width: '100%', padding: 12, background: '#D85A30', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 4 },
  btnLink: { display: 'block', width: '100%', padding: 12, background: '#D85A30', color: 'white', borderRadius: 8, fontSize: 14, fontWeight: 500, textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box', marginTop: 12 },
  erro: { color: '#A32D2D', fontSize: 13, background: '#FCEBEB', padding: '8px 12px', borderRadius: 8, marginBottom: 8 },
}
